import { Link } from "react-router-dom";

const quickLinks = [
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tvseries" },
  { label: "最新上线", to: "/category/latest" },
  { label: "热门推荐", to: "/category/hot" },
];

const regionLinks = [
  { label: "国产影视", to: "/category/china" },
  { label: "欧美影视", to: "/category/overseas" },
  { label: "日韩影视", to: "/category/japankorea" },
  { label: "关于我们", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70 mt-16">
      <div className="px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col md:flex-row gap-8 md:gap-12">
          <div className="md:max-w-sm">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-foreground-950">
                <i className="ri-tv-2-fill text-xl"></i>
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                蓝莓<span className="text-accent-500">视频</span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              蓝莓视频致力打造现代、便捷的影视内容聚合平台，聚合电影、电视剧等高清影视资源，让你轻松发现并欣赏最新大片与经典佳作。
            </p>
          </div>

          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-8">
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-4">热门分类</h4>
              <ul className="space-y-3">
                {quickLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <h4 className="text-sm font-medium text-foreground-950 mb-4">影视资源</h4>
              <ul className="space-y-3">
                {regionLinks.map((item) => (
                  <li key={item.to}>
                    <Link
                      to={item.to}
                      className="text-sm text-foreground-600 hover:text-accent-500 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-span-2 sm:col-span-1">
              <h4 className="text-sm font-medium text-foreground-950 mb-4">联系我们</h4>
              <ul className="space-y-3">
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-accent-500"></i>
                  <span>support@blueberry-video.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-wechat-line text-accent-500"></i>
                  <span>微信公众号：蓝莓视频</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-time-line text-accent-500"></i>
                  <span>服务时间 09:00 - 22:00</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2024 蓝莓视频 · 本站为影视内容演示站点，所有影视信息仅用于展示
          </p>
          <p className="text-xs text-foreground-500">
            我们尊重版权，不提供任何影视资源的下载与真实播放
          </p>
        </div>
      </div>
    </footer>
  );
}